import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { SnapshotSharedVariablesService } from 'src/app/modules/snapshot/Services/snapshot-shared-variables.service';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-header-nav-snap-output',
  templateUrl: './header-nav-snap-output.component.html',
  styleUrls: ['./header-nav-snap-output.component.css']
})
export class HeaderNavSnapOutputComponent {
  @Input() isAddClientDetails: boolean = false;
  @Input() snapNameNavHeader:string="";
  @Input() ImageURL: string = '';

  @Output() defaultPanelChange = new EventEmitter<boolean>();
  clientSnapDetails: any;
  // @Input() AcrossDropdown : any;
  snapshotListData: any;
  selected_Snap: string = "";
  AcrossDropdown  :any
  snapshotType_name: any = "";
  constructor(private router: Router, private _loaderService: LoaderService,public _configService: SnapshotService, private clientDetails: SnapshotSharedVariablesService) {
    this.ImageURL = '';
   }
   ngOnInit(): void {
    this.clientSnapDetails = this.clientDetails.clientDetails;
    this.snapshotListData = this._configService.SnapshotList;
    this.snapshotType_name = sessionStorage.getItem('snapshotType');

    this.selected_Snap = this.clientSnapDetails.study;
    if(localStorage.getItem("AcrossDropdown")){
      let value = localStorage.getItem("AcrossDropdown");
      this.AcrossDropdown = value;
      this.AcrossDropdown = JSON.parse(this.AcrossDropdown);

      const sortOrder = ['Single Brand', 'Multiple Brands', 'Multiple Markets','Audience Snapshot'];
      this.AcrossDropdown.sort((a: any, b: any) => {
      return sortOrder.indexOf(a.snapshotType_name) - sortOrder.indexOf(b.snapshotType_name);
    });
    }
    if(this._configService.snapshotTypeSelectedName){
      this._configService.snapshotTypeSelectedName =  this.snapshotType_name;
    }
  }

  showSnapshotDropdownVal: boolean = false;
  showSnapshotDropdown() {
    this.showSnapshotDropdownVal = !this.showSnapshotDropdownVal;
  }

  // navigateSnapshot(selectedSnap: string) {
  //   this._loaderService.showLoader();
  //   this._configService
  //     .getClientStudyData({
  //       client_code: this.clientSnapDetails.client_code,
  //       snapshot_name: selectedSnap,
  //     })
  //     .subscribe(async (b) => {
  //       var x = JSON.parse(b.body.Data);
  //       if (
  //         x != null &&
  //         x != undefined &&
  //         x != ''
  //       ) {
  //         let mainStudy = x.study_list[0].study_name;
  //         // let data: { client_code: string; study: string } = {
  //         //   client_code: this.selectedClientCode,
  //         //   study: this.selectedStudy,
  //         // };

  //         let data: { client_code: string; study: string; main_study: string, snapList: any, snapshotselected: string, sectionselected: any; subsectionselected: any } = {
  //           client_code: this.clientSnapDetails.client_code,
  //           study: selectedSnap,
  //           main_study: mainStudy,
  //           snapList: this._configService.SnapshotList,
  //           snapshotselected: this._configService.snapshotSelectedName,
  //           sectionselected: this._configService.selectedSection,
  //           subsectionselected: this._configService.selectedSubSection
  //         };

  //         if (x.product == "Standard") {
  //           this.router.navigateByUrl('Snapshot/snapshot-output', { state: data });
  //         }
  //         else if (x.product == "Custom") {
  //           //this.router.navigate(['Snapshot', 'custom-snapshot-output'], { state: data });
  //           //this.router.navigateByUrl('Snapshot/custom-snapshot-output', { state: data });
  //           this.router.navigateByUrl('/Snapshot', { skipLocationChange: true }).then(() => {
  //             this.router.navigateByUrl('Snapshot/custom-snapshot-output', { state: data});
  //           });
  //         //   this.router.navigateByUrl('dummy').then(() => {
  //         //     this.router.navigateByUrl('Snapshot/custom-snapshot-output', { state: data });
  //         // });
  //         }

  //       }
  //       else {
  //         this.router.navigateByUrl('landing');
  //       }
  //     })


  // }

  // @HostListener('document:click', ['$event'])
  // clickout(event: any) {
  //   if (event.target.id !== 'snapshot-dropdown' && event.target.id !== 'snapshot-text') {
  //     this.showSnapshotDropdownVal = false;
  //   }
  // }

  navigateSnapshot(item:any, section:any,  subsection:any) {
    let snapshotType = sessionStorage.getItem('snapshotType');
    sessionStorage.setItem('sectionName', section.section_name);
    let subSection = subsection.subsection_name ? subsection.subsection_name : "NA";
    sessionStorage.setItem('subsectionName', subSection);
    this.clientDetails.clientDetails.sectionselected = section.section_name;
    this.clientDetails.clientDetails.subsectionselected = subsection.subsection_name;
    this.clientSnapDetails.sectionselected = section.section_name;
    this.clientSnapDetails.subsectionselected = subsection.subsection_name;
    this._configService.selectedSection = section.section_name;
    this._configService.selectedSubSection = subsection.subsection_name;
    this.snapshotType_name = item.snapshotType_name;
    this._configService.snapshotTypeSelectedName = item.snapshotType_name;
    if(snapshotType == item.snapshotType_name){
      this._configService.tiggerSelectionSnapshotType = false;
       this._configService.isSameSnapshotType.next(true);
       this.defaultPanelChange.emit(true);
       return;
    }
    else{
      this._configService.tiggerSelectionSnapshotType = true;
      sessionStorage.removeItem('dataLoaded');
      sessionStorage.setItem('snapshotType', item.snapshotType_name);
      this._configService.isSameSnapshotType.next(false);
    }
   


    this._loaderService.showLoader();
    this._configService
      .getClientStudyData({
        client_code: this.clientSnapDetails.client_code,
        snapshot_name: this.clientSnapDetails.study
      })
      .subscribe(async (b) => {
        var x = JSON.parse(b.body.Data);
        if (
          x != null &&
          x != undefined &&
          x != ''
        ) {
          let mainStudy = x.study_list[0].study_name;
          // let data: { client_code: string; study: string } = {
          //   client_code: this.selectedClientCode,
          //   study: this.selectedStudy,
          // };

          if(x?.saveselection){
            this._configService.globalDefaultSelectionFlag = x.saveselection.find(
              (item: { key: string; value: boolean }) => item.key === "Global Default Selection"
            )?.value ?? false;
          }
          let data: { client_code: string; study: string; main_study: string, snapList: any, snapshotselected: string, sectionselected: any; subsectionselected: any, isAcrossdropDown:boolean } = {
            client_code: this.clientSnapDetails.client_code,
            study: this.clientSnapDetails.study ,
            main_study: mainStudy,
            snapList: this._configService.SnapshotList,
            snapshotselected: item.snapshotType_name,
            // sectionselected: this._configService.selectedSection,
            sectionselected: item.section[0].section_name,
            // subsectionselected: this._configService.selectedSubSection
            subsectionselected: item.section[0].subsection[0].subsection_name,
            isAcrossdropDown: true
          };

          if (x.product == "Standard") {
            this.router.navigateByUrl('Snapshot/snapshot-output', { state: data });
          }
          else if (x.product == "Custom") {
            //this.router.navigate(['Snapshot', 'custom-snapshot-output'], { state: data });
            //this.router.navigateByUrl('Snapshot/custom-snapshot-output', { state: data });
            
            this.router.navigateByUrl('/Snapshot', { skipLocationChange: true }).then(() => {
              this.router.navigateByUrl('Snapshot/custom-snapshot-output', { state: data});
            });
          //   this.router.navigateByUrl('dummy').then(() => {
          //     this.router.navigateByUrl('Snapshot/custom-snapshot-output', { state: data });
          // });
          }
          // this._loaderService.hideLoader();
        }
        else {
          this.router.navigateByUrl('landing');
          // this._loaderService.hideLoader();
        }
      })


  }
}
